var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 32H48C21.49 32 0 53.49 0 80V144C0 161.6 14.4 176 32 176H32V416C32 451.346 60.654 480 96 480H416C451.346 480 480 451.346 480 416V176H480C497.6 176 512 161.6 512 144V80C512 53.49 490.51 32 464 32ZM416 432H96C87.163 432 80 424.837 80 416V176H432V416C432 424.837 424.837 432 416 432ZM464 128H48V80H464V128ZM184 272H328C341.255 272 352 261.255 352 248V248C352 234.745 341.255 224 328 224H184C170.745 224 160 234.745 160 248V248C160 261.255 170.745 272 184 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArchive);
export default __webpack_public_path__ + "static/media/box-archive.d990e505ada6518ba7904a592703641b.svg";
export { ForwardRef as ReactComponent };